import produce from 'immer';
import { TTableActions, TTablesState } from '../../types/redux/tables';
import { SET_TABLE_FILTERS, SET_TABLE_SCROLL } from '../actions/tables';

const initialState: TTablesState = {};

export const tables = (state = initialState, action: TTableActions): TTablesState => {
    switch (action.type) {
        case SET_TABLE_FILTERS: {
            return produce(state, (draft) => {
                draft[action.tableName] = {
                    ...draft[action.tableName],
                    filters: action.payload,
                };
            });
        }
        case SET_TABLE_SCROLL: {
            return produce(state, (draft) => {
                draft[action.tableName] = {
                    ...draft[action.tableName],
                    scroll: action.payload,
                };
            });
        }
        default: {
            return state;
        }
    }
};
